/* ============================================================
   LE image zoom — click the framed gallery image to open a
   full-screen white viewer showing the framed mockup enlarged,
   with scroll / pinch to zoom and drag to pan. Close via the X,
   the backdrop, or Escape. LE product page only (.le-template);
   framing.js and the gallery are untouched — we clone the current
   composite into the overlay.
   ============================================================ */
(function () {
  'use strict';
  if (!document.querySelector('.le-template')) return;

  var overlay = null, stage = null, scale = 1, tx = 0, ty = 0;
  var MIN = 1, MAX = 4;

  function currentFrame() {
    return document.querySelector('.le-template .product-gallery__carousel-item.main-frame.is-selected')
      || document.querySelector('.le-template .product-gallery__carousel-item.main-frame');
  }

  function apply() {
    if (stage) stage.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
  }

  // Upgrade a Shopify CDN URL to a sharper size for the zoom view.
  function hiRes(src) {
    if (!src) return src;
    return src.replace(/_(300|400|500|600|800)x(\.|_)/, '_1600x$2').replace(/_(300|400|500|600|800)x\b/, '_1600x');
  }

  function open(frame) {
    if (overlay || !frame) return;

    // Read the live composite: aspect ratio, art image, frame overlay PNG and
    // the aperture inset framing.js applied. We rebuild it fresh in the
    // overlay (cloning breaks: the carousel's absolute positioning collapses
    // outside Flickity, so the frame PNG rendered below the art or not at all).
    var aspectEl = frame.querySelector('.aspect-ratio');
    var ar;
    if (aspectEl) { var ra = aspectEl.getBoundingClientRect(); ar = ra.height ? ra.width / ra.height : 0; }
    if (!ar || !isFinite(ar)) ar = parseFloat(frame.getAttribute('data-frame-ratio')) || 0.75;

    var artEl = frame.querySelector('img.main-art-img');
    var frameEl = frame.querySelector('img.frame-img');
    if (!artEl) return;
    var artSrc = artEl.currentSrc || artEl.src;
    var frameSrc = frameEl && !frameEl.classList.contains('not-visible') ? (frameEl.currentSrc || frameEl.src) : '';
    if (frameSrc && frameSrc.indexOf('http') !== 0 && frameSrc.indexOf('//') !== 0) frameSrc = '';

    // Measure the art's ACTUAL rendered box relative to the frame's aspect box
    // and reproduce those exact proportions in the overlay. This captures every
    // inset the page applies (print-scale padding, white-border container, …)
    // without re-implementing any of it — so all sizes/orientations/frames
    // mirror the page automatically.
    var inset = null;
    if (frameSrc && aspectEl) {
      var fr = aspectEl.getBoundingClientRect();
      var br = artEl.getBoundingClientRect();
      if (fr.width > 10 && fr.height > 10 && br.width > 2 && br.height > 2) {
        var pc = function (v, base) { return Math.max(0, (v / base * 100)).toFixed(3) + '%'; };
        inset = {
          top: pc(br.top - fr.top, fr.height),
          right: pc(fr.right - br.right, fr.width),
          bottom: pc(fr.bottom - br.bottom, fr.height),
          left: pc(br.left - fr.left, fr.width)
        };
      }
    }

    overlay = document.createElement('div');
    overlay.className = 'lez-overlay';
    overlay.innerHTML = '<button type="button" class="lez-close" aria-label="Close">&times;</button>' +
      '<div class="lez-hint">Scroll or pinch to zoom</div>' +
      '<div class="lez-stagewrap"><div class="lez-stage"></div></div>';
    stage = overlay.querySelector('.lez-stage');
    stage.style.width = 'min(92vw, calc(86vh * ' + ar + '))';

    // Same layering as the page: frame PNG on top of the art with
    // mix-blend-mode: multiply, so the overlay's white aperture lets the
    // print show through (without it the opaque PNG hides the art).
    var html = '<div style="position:relative;width:100%;aspect-ratio:' + ar + ';background:#fff;isolation:isolate;">';
    if (frameSrc && inset) {
      html += '<div style="position:absolute;top:' + inset.top + ';right:' + inset.right + ';bottom:' + inset.bottom + ';left:' + inset.left + ';">' +
        '<img src="' + hiRes(artSrc) + '" alt="" draggable="false" style="width:100%;height:100%;object-fit:contain;object-position:50% 50%;display:block;"></div>' +
        '<img src="' + hiRes(frameSrc) + '" alt="" draggable="false" style="position:absolute;inset:0;width:100%;height:100%;display:block;mix-blend-mode:multiply;">';
    } else {
      html += '<img src="' + hiRes(artSrc) + '" alt="" draggable="false" style="position:absolute;inset:0;width:100%;height:100%;object-fit:contain;object-position:50% 50%;display:block;">';
    }
    html += '</div>';
    stage.innerHTML = html;

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
    scale = 1; tx = 0; ty = 0; apply();
    bind();

    // Reveal the composite only once BOTH hi-res layers have loaded, so the
    // art and the frame overlay appear together instead of the art popping in
    // first. Falls back to showing whatever we have after 2.5s.
    var stageImgs = Array.prototype.slice.call(stage.querySelectorAll('img'));
    var pending = stageImgs.filter(function (im) { return !im.complete; }).length;
    if (pending > 0) {
      stage.style.opacity = '0';
      stage.style.transition = 'opacity 0.15s ease';
      var reveal = function () { stage.style.opacity = '1'; };
      var left = pending;
      stageImgs.forEach(function (im) {
        if (im.complete) return;
        im.addEventListener('load', function () { if (--left <= 0) reveal(); });
        im.addEventListener('error', function () { if (--left <= 0) reveal(); });
      });
      setTimeout(reveal, 2500);
    }
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
  }

  function close() {
    if (!overlay) return;
    document.removeEventListener('keydown', onKey);
    overlay.remove(); overlay = null; stage = null;
    document.body.style.overflow = '';
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  // Keep the pan within sensible bounds so the image can't be flung offscreen.
  function clampPan() {
    if (!stage) return;
    var bx = stage.offsetWidth * (scale - 1) / 2 + 40;
    var by = stage.offsetHeight * (scale - 1) / 2 + 40;
    tx = Math.max(-bx, Math.min(bx, tx));
    ty = Math.max(-by, Math.min(by, ty));
  }

  // Multiplicative zoom that keeps the point under the cursor fixed.
  // With transform-origin at the centre: a screen point p sits at
  // centre + t + p0·s, so after s→s' the translation must become
  // t + c·(1 − s'/s) where c is the cursor offset from the CURRENT centre.
  // (The old additive version drifted once panned — that was the glitch.)
  function zoomAt(clientX, clientY, factor) {
    var rect = stage.getBoundingClientRect();
    var prev = scale;
    scale = Math.min(MAX, Math.max(MIN, scale * factor));
    if (scale === prev) return;
    if (scale === MIN) { tx = 0; ty = 0; apply(); return; }
    var k = scale / prev;
    var cx = clientX - (rect.left + rect.width / 2);
    var cy = clientY - (rect.top + rect.height / 2);
    tx = tx + cx * (1 - k);
    ty = ty + cy * (1 - k);
    clampPan();
    apply();
  }

  function bind() {
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.lez-close') || e.target.classList.contains('lez-stagewrap')) close();
    });
    document.addEventListener('keydown', onKey);

    // Smooth, proportional wheel/trackpad zoom (multiplicative, not stepped).
    overlay.addEventListener('wheel', function (e) {
      e.preventDefault();
      var d = Math.max(-60, Math.min(60, e.deltaY));
      zoomAt(e.clientX, e.clientY, Math.exp(-d * 0.004));
    }, { passive: false });

    // double-click / double-tap toggles zoom
    stage.addEventListener('dblclick', function (e) {
      if (scale > 1) { scale = 1; tx = 0; ty = 0; apply(); }
      else zoomAt(e.clientX, e.clientY, 2.4);
    });

    // drag to pan when zoomed (single pointer only — a second finger means pinch)
    var dragging = false, sx = 0, sy = 0, stx = 0, sty = 0;
    stage.addEventListener('pointerdown', function (e) {
      if (scale <= 1) return;
      dragging = true; sx = e.clientX; sy = e.clientY; stx = tx; sty = ty;
      stage.setPointerCapture(e.pointerId); stage.style.cursor = 'grabbing';
    });
    stage.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      tx = stx + (e.clientX - sx); ty = sty + (e.clientY - sy);
      clampPan();
      apply();
    });
    stage.addEventListener('pointerup', function () { dragging = false; stage.style.cursor = ''; });
    stage.addEventListener('pointercancel', function () { dragging = false; stage.style.cursor = ''; });

    // pinch zoom (two-finger) — zooms around the pinch midpoint and suspends
    // the one-finger pan so the two gestures don't fight (source of jitter).
    var pinchDist = 0;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) { pinchDist = dist(e.touches); dragging = false; }
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pinchDist) {
        e.preventDefault();
        var d = dist(e.touches);
        if (d > 0) {
          var midX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
          var midY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
          zoomAt(midX, midY, d / pinchDist);
          pinchDist = d;
        }
      }
    }, { passive: false });
    stage.addEventListener('touchend', function (e) {
      if (e.touches.length < 2) pinchDist = 0;
    }, { passive: true });
    function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }
  }

  // click the gallery frame to open (ignore arrows / dots)
  document.addEventListener('click', function (e) {
    if (e.target.closest('.mgs-arrow, .mgs-dot, .product-gallery__thumbnail')) return;
    var frame = e.target.closest('.le-template .product-gallery__carousel-item.main-frame');
    if (frame && !overlay) { e.preventDefault(); open(frame); }
  });
})();
